import { CartModal } from "components/CartModal/CartModal";
import { Button } from "components/DesignSystem/Button/Button";
import { GO_TO_CART_CTA } from "constants/filingActionCta";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import { MouseEvent } from "react";
import { stopPropagation } from "utils/stopPropagation";

type RedirectFromTaskToCartProps = {
  entityId: string;
  onClick?: () => void;
};

export const RedirectFromTaskToCart = ({
  entityId,
  onClick,
}: RedirectFromTaskToCartProps) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const cartModal = useModal();

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    onClick?.();
    cartModal.open();
  };

  return (
    <>
      <Button size="xsmall" onClick={handleClick}>
        {GO_TO_CART_CTA}
      </Button>
      {cartModal.isOpen && (
        <div onClick={stopPropagation}>
          <CartModal
            open={cartModal.isOpen}
            onClose={cartModal.close}
            entityIdFromProps={entityId}
            groupIdFromProps={groupId}
            hideEntitySelector
          />
        </div>
      )}
    </>
  );
};
